module.exports = __webpack_public_path__ + "img/yundian@2x.0b81c92d.png";